import { Header } from './layout/header.js';

document.addEventListener('DOMContentLoaded', () => {
	new Header();
});
